import { useMutation, useQueryClient } from '@tanstack/react-query';
import { consumerApi, consumerPlanKeys, type PremiumRangeRequest } from '../api/consumer-api';

export function usePremiumRangeRequest(clientId: string) {
  return useMutation({
    mutationFn: (request: PremiumRangeRequest) => consumerApi.requestPremiumRange(clientId, request),
  });
}

export function useSubmitApplication(clientId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: {
      coverage: ConsumerApplicationCoverage;
      answers: ConsumerApplicationAnswers;
      consentIds: string[];
    }) =>
      consumerApi.submitApplication(clientId, body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: consumerPlanKeys.detail(clientId) }),
  });
}
